var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"toolkit-mark",class:[
    ("toolkit-mark--" + _vm.size),
    ("toolkit-mark--" + _vm.theme),
    _vm.showLogo ? 'toolkit-mark--logo' : 'toolkit-mark--monogram' ],style:(_vm.markStyle),attrs:{"title":_vm.name}},[(_vm.showLogo)?_c('img',{staticClass:"toolkit-mark__img",attrs:{"src":_vm.logoUrl,"alt":_vm.name},on:{"error":_vm.onLogoError}}):[_vm._v(_vm._s(_vm.initial))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }